module.exports = __webpack_public_path__ + "img/tablero.cc387c8f.gif";